import React from "react";

const ListCard = ({ children, selected, className }) => (
  <div
    className={`bg-background shadow-md rounded-lg p-4 text-text relative ${selected ? "border-l-4 border-r-4 border-primary" : ""} ${className}`}
  >
    {children}
  </div>
);

export default ListCard;
